<template>
  <div
    class="chuangguan"
    :class="ifMobile ? 'mobile' : 'comp'"
  >
    <div class="index">
      <div class="header">{{ user.name }}的闯关战报</div>
      <div class="name">
        <div class="icon">
          <img
            :src="`https://alphahr.oss-cn-beijing.aliyuncs.com/documents/upload/${user.alpha_account}.jpg`"
            alt=""
          />
        </div>
        <span>{{ user.name }}</span>
      </div>
      <div class="info">
        <div
          class="text"
          style="justify-content: flex-start"
          v-if="user.stars || user.stars === 0"
        >段位等级：<b
            :title="rank.desc"
            :style="`color:${rank.color}`"
          >{{ rank.name }}</b></div>
        <div class="text">
          <span>星级：<b class="star">★</b> × {{user.stars}}</span>
        </div>
        <div
          class="text"
          v-if="user.current_step_name&&user.current_lesson_name"
        >
          <span style="width:100%">目前进度：{{user.current_step_name}}-{{user.current_lesson_name}}</span>
        </div>
        <div class="text">
          <span> 职位：{{role.join('、')}} </span>
        </div>
        <div class="inner-info">
          <template v-if="!loading">
            同期平均<b>{{ava}}关</b>；打败了<b>{{percent}}%</b>的人
          </template>
          <template v-else>
            <div class="loading">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </template>
        </div>
      </div>
      <div
        class="tips"
        v-if="levelList.length&&user.stars || user.stars === 0"
      >
        进阶建议：<br />
        距离下一段位还差{{20 - (user.stars % 20)}}颗星；{{levelList.length?`高分技能是【${levelList[0].lesson_name}】【${levelList[1].lesson_name}】，建议冲分技能是【${levelList[2].lesson_name}】【${levelList[3].lesson_name}】【${levelList[4].lesson_name}】`:''}}
      </div>
      <div class="buttons">
        <!-- <div class="btn"><span>查看排行榜</span></div> -->
        <!-- <div class="btn"><span>王者英雄榜</span></div> -->
        <!-- <div class="btn"><span>我的成就</span></div> -->
        <div
          class="btn full"
          @click="start"
        ><span>{{user.stars === 0?'去闯关':'继续去通关'}}</span></div>
        <!-- <div class="btn"><span>分享</span></div> -->
      </div>
    </div>
  </div>
</template>
<script>
const echarts = require('echarts/lib/echarts')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')
require('echarts/lib/chart/radar')
export default {
  data() {
    return {
      ifMobile: false,
      curTab: '顾问方向',
      myChart: null,
      user: {},
      通用: {
        目标导向: 0,
        抗压能力: 0,
        适应能力: 0,
        决策行动: 0,
        学习能力: 0,
        逻辑分析: 0,
      },
      顾问方向: {
        人际建立: 0,
        沟通说服: 0,
        匹配分析: 0,
        意向把控: 0,
        人选推动: 0,
        mapping: 0,
      },
      客户经理方向: {
        人际建立: 0,
        沟通说服: 0,
        客户开拓: 0,
        谈判能力: 0,
        客情维护: 0,
        项目推进: 0,
      },
      业务支持方向: {
        人际建立: 0,
        成就他人: 0,
        与人合作: 0,
        数据维护: 0,
        支持协作: 0,
        书面表达: 0,
      },
      管理能力: {
        成就他人: 0,
        战略思维: 0,
        创新能力: 0,
        策略经营: 0,
        计划组织: 0,
        领导监督: 0,
      },
      rateArr: {
        顾问方向: [
          '目标导向',
          '抗压能力',
          '决策行动',
          '逻辑分析',
          '人际建立',
          '沟通说服',
          '匹配分析',
          '意向把控',
          '人选推动',
          'mapping',
        ],
        客户经理方向: [
          '目标导向',
          '抗压能力',
          '适应能力',
          '决策行动',
          '学习能力',
          '逻辑分析',
          '人际建立',
          '沟通说服',
          '客户开拓',
          '谈判能力',
          '客情维护',
          '项目推进',
        ],
        业务支持方向: ['人际建立', '成就他人', '与人合作', '数据维护', '支持协作', '书面表达'],
        管理能力: [
          '目标导向',
          '抗压能力',
          '适应能力',
          '决策行动',
          '学习能力',
          '逻辑分析',
          '人员管理',
          '战略思维',
          '创新能力',
          '策略经营',
          '计划组织',
          '领导监督',
        ],
      },
      rankList: [
        {
          name: '青铜',
          desc: '言在黄白之间，其色半出，不全成也',
          limit: 20,
          color: '#fffbf0',
        },
        {
          name: '白银',
          desc: '明日中天之色',
          limit: 40,
          color: '#f7ab00',
        },
        {
          name: '黄金',
          desc: '冬去春来，柳出新芽之色',
          limit: 60,
          color: '#C0D09D',
        },
        {
          name: '铂金',
          desc: '螺青点出莫山色，石绿染成春浦潮',
          limit: 80,
          color: '#256535',
        },
        {
          name: '钻石',
          desc: '天青雨过破云之处，天降露水染碧之色',
          limit: 100,
          color: '#7EC0EE',
        },
        {
          name: '星耀',
          desc: '丹砂之石，淬火研磨，盐泥固济，大火锻之，得为灵砂之色',
          limit: 120,
          color: '#CD0000',
        },
        {
          name: '王者',
          desc: '金之优者，名曰紫磨，犹人之有圣也',
          limit: 140,
          color: '#CD8500',
        },
      ],
      rank: {},
      role: [],
      levelList: [],
      ava: '',
      percent: '',
      rankNum: '',
      loading: true,
      scoreItem: ['顾问方向', '客户经理方向', '业务支持方向', '管理能力'],
    }
  },
  computed: {
    avaScore() {
      return {
        通用:
          Math.ceil(
            (Object.keys(this.通用)
              .map((e) => Object.assign({}, this.通用)[e])
              .reduce((a, b) => a + b, 0) /
              Object.keys(this.通用).length) *
              10,
          ) / 10,
        顾问方向:
          Math.ceil(
            (this.rateArr.顾问方向
              .map((e) => Object.assign({}, this.顾问方向, this.通用)[e])
              .reduce((a, b) => a + b, 0) /
              this.rateArr.顾问方向.length) *
              10,
          ) / 10,
        客户经理方向:
          Math.ceil(
            (this.rateArr.客户经理方向
              .map((e) => Object.assign({}, this.客户经理方向, this.通用)[e])
              .reduce((a, b) => a + b, 0) /
              this.rateArr.客户经理方向.length) *
              10,
          ) / 10,
        业务支持方向:
          Math.ceil(
            (this.rateArr.业务支持方向
              .map((e) => Object.assign({}, this.业务支持方向, this.通用)[e])
              .reduce((a, b) => a + b, 0) /
              this.rateArr.业务支持方向.length) *
              10,
          ) / 10,
        管理能力:
          Math.ceil(
            (this.rateArr.管理能力
              .map((e) => Object.assign({}, this.管理能力, this.通用)[e])
              .reduce((a, b) => a + b, 0) /
              this.rateArr.管理能力.length) *
              10,
          ) / 10,
      }
    },
  },
  methods: {
    toggle() {
      this.showChuangguan = !this.showChuangguan
    },
    async indexInit() {
      await this.getUserInfo()
      // await this.getData()
      // const chartDom = document.getElementById('radar-echart')
      // this.myChart = echarts.init(chartDom)
      // let option = this.getOption()
      // option && this.myChart.setOption(option)
    },
    formatProgress(val) {
      return (val / 100) * 5
    },
    changeTab(item) {
      this.curTab = item
      let option = this.getOption()
      option && this.myChart.setOption(option)
    },
    routerTo(path) {
      this.$router.push(path)
    },
    async start() {
      if (this.user.stars === 0) {
        this.$emit('changeTab', 'chuangguan')
      } else {
        const { data } = await app.service('misc').getLessonStarDetail({
          tel: app.user.个人手机 || app.user.工作手机 || '',
          lesson_id: this.user.current_lesson_id,
        })
        if (this.ifMobile) {
          location.href = data.课程链接
        } else {
          window.open(data.课程链接, '_blank')
        }
      }
    },
    async getUserInfo() {
      const { data } = await app.service('misc').getLessonMember({ tel: app.user.个人手机 || app.user.工作手机 || '' })
      this.role = app.user.角色
      this.user = data
      this.rank = this.rankList[Math.floor(Math.abs(this.user.stars) / 20)]
      const res1 = await app.service('misc').getLessonLevels({ tel: app.user.个人手机 || app.user.工作手机 || '' })
      if (res1.status === 'fail') {
        this.$alert(
          `<h3 style="text-align:center">${res1.msg}</h3><p style="text-align:center">请添加管理员微信询问解决~</p><div><img style="margin:20px auto 0;width:200px;height:200px;" src="https://alphahr-files-backup.oss-cn-beijing.aliyuncs.com/wechat/jobHunting/common/fuxingqrcode.png" alt=""></div>`,
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            center: true,
            showClose: false,
          },
        )
        this.loading = false
        return
      }
      const data1 = res1.data
      this.levelList = data1.levelList
      const { data: data2 } = await app.service('misc').getLessonMembers()
      const rank = data2.map((d) => d.current_lesson_id)
      rank.sort((a, b) => b - a)
      this.rankNum = rank.findIndex((r) => r === this.user.current_lesson_id) + 1
      this.ava = Math.ceil(rank.reduce((a, b) => a + b, 0) / rank.length)
      this.percent = (100 - (this.rankNum * 100) / rank.length).toFixed(2)
      this.loading = false
    },
    getOption() {
      if (!this.myChart) {
        return
      }
      let option
      const indicator = this.rateArr[this.curTab].map((e) => ({
        text: e,
        max: 5,
      }))
      const value = indicator.map((e) => this.通用[e.text] || this[this.curTab][e.text])
      option = {
        radar: {
          // shape: 'circle',
          indicator,
        },
        series: [
          {
            name: '1',
            type: 'radar',
            areaStyle: {},
            data: [
              {
                value,
              },
            ],
          },
        ],
      }
      return option
    },
    async init() {
      await this.indexInit()
    },
  },
  mounted() {
    this.ifMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
    this.init()
  },
}
</script>
<style scoped>
.index {
  background-image: url('https://alphahr-files-backup.oss-cn-beijing.aliyuncs.com/wechat/jobHunting/newChuangguan/bg.png');
  background-size: 100% 100%;
}
.comp .index {
  padding-bottom: 80px;
}
.mobile .index {
  padding-bottom: 120px;
}
/* .header {
  width: 100%;
  height: 240px;
  display: flex;
  align-items: center;
  padding: 20px 40px;
  background-image: url('./img/repeat-bg.png');
  background-repeat: repeat-y;
  background-size: 100% auto;
}
.icon {
  width: 200px;
  height: 200px;
  flex-shrink: 0;
  margin-right: 30px;
}
.icon img {
  width: 100%;
  height: 100%;
  display: block;
}
.info {
  flex-grow: 1;
  font-size: 16px;
  color: #fff;
}
.info > div {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.info .square {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  background-color: #fffc37;
  margin-left: 10px;
}
.info i {
  color: #ff9900;
  display: block;
  margin-left: 10px;
  font-size: 18px;
}
.info b {
  margin-left: 10px;
}
.info span {
  font-size: 12px;
}
.edit-btn {
  width: 180px;
  height: 30px;
  background-color: rgba(206, 152, 174);
  font-size: 14px;
  font-weight: 600;
  align-items: center;
  justify-content: center;
  margin: 15px auto 0;
  cursor: pointer;
}
.main {
  padding: 20px;
}
.radar {
  width: 100%;
}
#radar-echart {
  width: 400px;
  height: 300px;
  margin: 0 auto;
}
.score {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid rgba(206, 152, 174);
  border-top: 1px solid rgba(206, 152, 174);
}
.score-item {
  width: 50%;
  border-bottom: 1px solid rgba(206, 152, 174);
  border-right: 1px solid rgba(206, 152, 174);
  cursor: pointer;
}
.score-name {
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(206, 152, 174);
  border-bottom: 1px solid rgba(206, 152, 174);
  font-size: 16px;
  font-weight: 600;
  height: 40px;
}
.score-value {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.score-detail-title {
  font-size: 16px;
  font-weight: 600;
  padding: 15px 0;
  margin-bottom: 5px;
}
.score-detail-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.score-detail-item {
  width: 50%;
  height: 40px;
  margin-bottom: 10px;
}
.score-detail-name {
  font-size: 14px;
  margin-bottom: 8px;
}
.tab {
  width: 550px;
  height: 40px;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  background-color: #ecdff5;
  border-top: 1px solid #dfdfdf;
}
.tab-item {
  width: 33%;
  flex-grow: 1;
  border-right: 1px solid #d7d7d7;
  height: 25px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #999;
  cursor: pointer;
}
.tab-item:last-of-type {
  border-right: none;
}
.mobile .icon {
  width: 120px;
  height: 120px;
  margin-right: 10px;
}
.mobile .header {
  padding: 15px;
  height: 170px;
}
.mobile .info {
  font-size: 14px;
}
.mobile .main {
  padding: 15px;
}
.mobile #radar-echart {
  width: 340px;
  height: 260px;
}
.mobile .tab {
  width: 100vw;
}
.mobile .score-tab {
  width: 100vw;
}
.mobile .score-tab-item {
  font-size: 14px;
}
.score-tab {
  width: 550px;
  display: flex;
  align-items: center;
}
.score-tab-item {
  height: 60px;
  width: 25%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 16px;
}
.active-tab {
  font-weight: 600;
  color: rgba(206, 152, 174);
  border-bottom: 3px solid rgba(206, 152, 174);
}
.active {
  font-weight: 600;
  color: #333;
}
.rank > div,
.rank > b {
  cursor: pointer;
} */
.mobile .header {
  height: 60px;
}
.mobile .info {
  width: 340px;
}
.mobile .inner-info {
  width: 290px;
  font-size: 14px;
}
.mobile .inner-info b {
  font-size: 18px;
}
.header {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 400;
  color: #ffffff;
  box-shadow: 0 2px 6px 4px #00000082;
}
.name {
  padding: 50px 0 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.icon {
  width: 110px;
  height: 110px;
  border: 2px solid #0090f1;
  margin-bottom: 20px;
  border-radius: 50%;
  overflow: hidden;
}
.icon img {
  width: 100%;
  height: 100%;
  display: block;
}
.name span {
  font-size: 26px;
  color: #ffffff;
}
.info {
  width: 493px;
  padding: 22px;
  border: 2px solid;
  background: #141921;
  border-image: linear-gradient(90deg, #e4035d, #38adfd) 10 10;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  margin: 0 auto 20px;
}
.text {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 20px;
  font-weight: 400;
  color: #ffffff;
  margin-bottom: 15px;
}
.text b {
  color: #3ca9f9;
}
.text span {
  width: 50%;
}
.inner-info {
  width: 350px;
  height: 40px;
  border: 2px solid #40a5f5;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 18px;
  white-space: nowrap;
  justify-content: center;
}
.inner-info::after {
  top: -4px;
  left: -4px;
  content: '';
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-top: 20px solid #141921;
  border-right: 20px solid transparent;
  filter: drop-shadow(2px 2px 0px #40a5f5);
}
.inner-info::before {
  bottom: -4px;
  right: -4px;
  content: '';
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-bottom: 20px solid #141921;
  border-left: 20px solid transparent;
  filter: drop-shadow(-2px -2px 0px #40a5f5);
}
.inner-info b {
  color: #e83423;
  font-size: 22px;
}
.tips {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #3ca9f9;
  margin-bottom: 20px;
  padding: 0 30px;
}
.buttons {
  display: flex;
  flex-flow: wrap;
  padding: 0 30px;
}
.btn {
  width: 138px;
  height: 34px;
  background: #141921;
  border: 1px solid #0090f1;
  border-radius: 4px 4px 4px 4px;
  margin-right: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #ffffff;
  margin-bottom: 29px;
  transform: skewX(-15deg);
  cursor: pointer;
}
.btn span {
  transform: skewX(15deg);
}
.full {
  border: none;
  background: linear-gradient(90deg, #e4035d 0%, #38adfd 100%);
}
.star {
  color: #06edf6 !important;
  font-size: 24px;
}
.loading {
  width: 150px;
  height: 15px;
  margin-left: -98px;
  margin-bottom: 8px;
}
.loading span {
  display: inline-block;
  width: 15px;
  height: 100%;
  margin: 0 15px;
  background: #06edf6;
  -webkit-transform-origin: right bottom;
  -webkit-animation: load 1s ease infinite;
}
.loading span:last-child {
  margin-right: 0px;
}
@-webkit-keyframes load {
  0% {
    opacity: 1;
    -webkit-transform: scale(1);
  }
  100% {
    opacity: 0;
    -webkit-transform: rotate(90deg) scale(0.3);
  }
}
.loading span:nth-child(1) {
  -webkit-animation-delay: 0.13s;
}
.loading span:nth-child(2) {
  -webkit-animation-delay: 0.26s;
}
.loading span:nth-child(3) {
  -webkit-animation-delay: 0.39s;
}
.loading span:nth-child(4) {
  -webkit-animation-delay: 0.52s;
}
.loading span:nth-child(5) {
  -webkit-animation-delay: 0.65s;
}
</style>
